import styled from '@emotion/styled';

export const InputBox = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-evenly;
  align-items: center;
  width: 100%;
  flex-grow: 1;
`;
